<form [formGroup]="careAcceptionForm">
  <div class="field">
    <label class="field-required">Is PAC Member willing to accept HH care after discharge?</label>
      <div class="p-field-value">
        <div class="flex boolean-radio">
          <p-radioButton 
            formControlName="acceptHhCare" 
            inputId="yes" 
            class="mr-2"
            [value]="'Yes'">
          </p-radioButton>
          <label for="yes">Yes</label>
          <p-radioButton 
            formControlName="acceptHhCare" 
            inputId="no" 
            class="mr-2 ml-4"
            [value]="'No'">
          </p-radioButton>
          <label for="no">No</label>
        </div>
      </div>
  </div>

  @if (acceptHhCare?.value === 'Yes') {
    <div class="field">
      <label>Anticipated Discharge Date: </label>
      <div class="p-field-valuen" style="width: 31%">
        <p-date-picker
          formControlName="anticipatedDischargeDate"
          tabindex="1"
          appendTo="body"
          placeholder="mm/dd/yyyy"
          [readonlyInput]="true"
          [showTime]="false"
          [showIcon]="true"
          [showClear]="true"
        >
        </p-date-picker>
      </div>
    </div>
  } @else {
    <p-message severity="secondary" icon="pi pi-info-circle" class="mt-6 mb-4">
      <div>
        <p class="font-semibold">Please Note</p>
        <ul class="ps-6 list-disc">
          <li>
            If the member later decides they would like home health (HH) services, they can contact their PCP or specialist to obtain the appropriate orders. 
          </li>
          <li>
            If the member needs care navigation support, please contact your Provider Network representative to connect them with available care navigation services
          </li>
        </ul>
      </div>
    </p-message>
  }
</form>
<div class="flex justify-end">
  <button
    type="button"
    pButton
    label="Cancel"
    class="p-button-secondary mr-2"
    (click)="cancel()">
  </button>
  <button
    type="button"
    pButton
    [label]="acceptHhCare?.value === 'No' ? 'End Request Process' : 'Confirm'"
    [disabled]="careAcceptionForm.invalid"
    (click)="confirm()">
  </button>
</div>
